<template>
  <div class="investor-banner">
    <BaseContainer>
      <div class="investor-banner__wrapper">
        <div class="investor-banner__image">
          <figure>
            <img :src="getImage" alt="Alt description for the image">
          </figure>
        </div>
        <div class="investor-banner__info">
          <div>
            <h3 class="investor-banner__header">
              <TextHeading block>{{ category }}</TextHeading>
            </h3>
          </div>
          <div class="investor-banner__share-details">
            <h3 class="investor-banner__price">
              <TextHeading variant="xl" color="secondary" block>{{ price }}</TextHeading>
            </h3>
            <span class="investor-banner__currency">{{ currency }}</span>
            <span class="investor-banner__text">{{ info }}</span>
          </div>
          <div class="investor-banner__button-wrapper">
            <BaseButton class="investor-banner__button" variant="white" width="full">
              Share Price Chart
              <BaseIcon name="arrow_forward" size="18"></BaseIcon>
            </BaseButton>
            <BaseButton class="investor-banner__button" variant="white" width="full">
              Share Price Calculator
              <BaseIcon name="arrow_forward" size="18"></BaseIcon>
            </BaseButton>
            <BaseButton class="investor-banner__button" variant="white" width="full">
              Historic Download
              <BaseIcon name="arrow_forward" size="18"></BaseIcon>
            </BaseButton>
          </div>
        </div>
      </div>
    </BaseContainer>
  </div>
</template>

<script>
import BaseIcon from '../elements/BaseIcon.vue'
import BaseButton from '../elements/BaseButton.vue'
import TextHeading from '../elements/TextHeading.vue'
import BaseContainer from '../elements/BaseContainer.vue'
export default {
  name: 'InvestorsBanner',
  components: { BaseContainer, TextHeading, BaseButton, BaseIcon },
  data() {
    return {
      category: "Today's Share Price",
      price: '247.76',
      currency: 'GBp',
      info: 'Change: -54.00p (-1.10 % )'
    }
  },
  props: {
    image01: {
      type: String,
      default: 'hilmore-house-02.png'
    }
  },
  computed: {
    getImage() {
      return require('@/assets/images/' + this.image01)
    }
  }
}
</script>

<style lang="postcss">
.investor-banner {
  @apply w-full;
  background-image: linear-gradient(#e6ebe9 65%, white 0%);
}
.investor-banner__wrapper {
  @apply flex flex-col justify-center w-full;
  box-shadow: 0 5px 30px 0 rgba(0, 0, 0, 0.15);
}
.investor-banner__image {
  @apply w-full bg-white;
}
.investor-banner__image figure {
  @apply block aspect-ratio-16/9 bg-white relative overflow-hidden h-full;
}
.investor-banner__image img {
  @apply block absolute bottom-0 inset-x-0 min-w-full min-h-full;
  object-fit: cover;
}
.investor-banner__info {
  @apply flex flex-col items-start w-full py-4 pl-4  pr-8 bg-white;
}
.investor-banner__header {
  @apply mb-4 w-full;
}
.investor-banner__text {
  @apply mb-8 text-lg font-light whitespace-no-wrap;
}
.investor-banner__share-details {
  @apply flex flex-wrap items-baseline;
}
.investor-banner__price {
  @apply mr-2;
}
.investor-banner__currency {
  @apply text-secondary text-xl font-semibold mr-4;
}
.investor-banner__button-wrapper {
  @apply flex-1 flex flex-col justify-end w-full;
  flex-basis: auto;
}
.investor-banner__button {
  @apply text-secondary flex justify-between;
}
.investor-banner__button:hover {
  @apply text-primary;
}
@screen md {
  .investor-banner {
    background-image: linear-gradient(#e6ebe9 25%, white 0%);
  }
  .investor-banner__image {
    @apply w-7/12 pr-4;
  }
  .investor-banner__image img {
    @apply max-h-full;
  }
  .investor-banner__wrapper {
    @apply flex-row;
    box-shadow: 0 5px 30px 0 rgba(0, 0, 0, 0.15);
  }
  .investor-banner__info {
    @apply py-6 w-5/12;
  }
}
</style>